import _ from 'lodash';
export const CREATE_MODE = "create";
export const MODIFY_MODE = "modify";

export const adjustRowsObject = (rows) => {
    if (!Array.isArray(rows.rows)) {
        if (!rows.rows) {
            return {...rows, rows: []}
        }
        return rows;
    }

    const newRows = _.cloneDeep(rows);
    newRows.rows = rows.rows.map(row => {
        const newObjRow = {};
        rows.columns.forEach((col, idx) => {
            newObjRow[col] = row[idx];
        })
        return newObjRow
    })
    return newRows;
}